// Optional dictation through the browser's SpeechRecognition. Never required: without it the
// composer just has the textarea. Some browsers (Chrome) send the audio to their own speech service.

export interface SpeechResultLike {
  isFinal: boolean;
  0: { transcript: string };
}

export interface SpeechRecognitionLike {
  lang: string;
  continuous: boolean;
  interimResults: boolean;
  onresult: ((e: { resultIndex: number; results: ArrayLike<SpeechResultLike> }) => void) | null;
  onerror: ((e: { error?: string }) => void) | null;
  onend: (() => void) | null;
  start(): void;
  stop(): void;
}

export type SpeechCtor = new () => SpeechRecognitionLike;

/** Dictation stays off until the owner approves where the audio goes: Chrome's SpeechRecognition sends
 * it to Google's speech service, and a note on a loan page may name the borrower. Turning it on is a
 * product decision, not a code default. */
export const DICTATION_ENABLED = false;

export function speechCtor(win: unknown = typeof window === "undefined" ? undefined : window): SpeechCtor | null {
  const w = win as { SpeechRecognition?: SpeechCtor; webkitSpeechRecognition?: SpeechCtor } | undefined;
  return w?.SpeechRecognition ?? w?.webkitSpeechRecognition ?? null;
}

/** Appends a dictated phrase to the note with one space between. */
export function appendDictation(note: string, phrase: string): string {
  const p = phrase.trim();
  if (!p) return note;
  if (!note.trim()) return p;
  return /\s$/.test(note) ? note + p : `${note} ${p}`;
}
